import React from 'react';
import './footer.css'
import {Typography} from "@material-ui/core";
import ResumeData from '../utils/ResumeData'
const  Footer = () => {
    return (
        <div className="footer">
            <div className="footer_left">
                <Typography className="footer_name">{ResumeData.name}</Typography>
            </div>
            <div className="footer_right">
                <Typography className="footer_copyright">
                    Design and Develop By <a href="https://github.com/arup-paul">Arup Paul</a>
                    <br/>
                    Template Idea From ThemeForest
                </Typography>
            </div>
        </div>
    );
}

export default Footer;